import * as React from "react";

import { TableHeaderCell, TableRow } from "simplydo/react/ui/table";

const cellStyle = { border: "none" };

interface HeaderRangeProps {
  /** Selected dates range. */
  content: string;
}

function HeaderRange(props: HeaderRangeProps) {
  const { content } = props;

  return (
    <TableRow>
      <TableHeaderCell style={cellStyle} colSpan={7}>
        {content}
      </TableHeaderCell>
    </TableRow>
  );
}

export default HeaderRange;
